import { render } from "./master-page.vue?vue&type=template&id=4ac66be7"
import script from "./master-page.vue?vue&type=script&lang=js"
export * from "./master-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__